/** Explicit recovery honors the same save guard as normal navigation, then drains writes. */
export async function safePageReload(
  drain: () => Promise<void>,
  target: Pick<EventTarget, 'dispatchEvent'> = window,
  reload: () => void = () => location.reload(),
): Promise<void> {
  await new Promise<void>((resolve, reject) => {
    const event = new CustomEvent('luuta:before-navigate', {
      cancelable: true,
      detail: { proceed: resolve, onError: reject },
    })
    if (target.dispatchEvent(event)) resolve()
  })
  await drain()
  reload()
}
